import type { Booking } from "../types";
import { normalizeBookingStatusFromApi } from "./bookingRowGuard";

/**
 * Map wire / Firestore values (numeric codes, lowercase `"pending"`, etc.) to canonical `Booking.status`.
 * Re-exported entry point for admin calendar + Client Profile parity.
 */
export function canonicalizeBookingStatusInput(value: unknown): Booking["status"] | null {
  return normalizeBookingStatusFromApi(value);
}

export { normalizeBookingStatusFromApi } from "./bookingRowGuard";

/** Core operational rows the admin calendar must stay in sync with (plus Completed on the server). */
export const ADMIN_CALENDAR_CORE_STATUSES = ["Confirmed", "Pending", "new_request"] as const;

/** Split-dot: emerald — scheduled/confirmed/completed visits (not “open request” or awaiting confirm). */
export function isAdminCalendarConfirmedDotStatus(status: Booking["status"]): boolean {
  return status === "Confirmed" || status === "Completed";
}

/** Split-dot: amber — needs confirmation or inbox-style booking row. */
export function isAdminCalendarPendingDotStatus(status: Booking["status"]): boolean {
  return status === "Pending" || status === "new_request";
}
